import { Box, Paper, alpha, Chip, styled, css } from '@mui/material';

interface StyledContainerProps {
  selected?: boolean;
  isCancelStep?: boolean;
}

interface StyledTeamDotProps {
  color?: string;
}

export const HeaderContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(2)};
`;

export const StepContainer = styled(Paper)<StyledContainerProps>`
  width: 217px;
  box-sizing: border-box;
  max-height: 120px;
  border-radius: 16px;
  position: relative;
  transition: all 0.2s ease-in-out;

  ::before {
    background-color: ${({ theme }) => theme.palette.paper.background};
    content: '';
    position: absolute;
    border-radius: inherit;
    inset: 0;
    z-index: -1;
  }

  ${({ selected, theme }) =>
    selected
      ? css`
          border: 1px solid ${theme.palette.primary.main};
          background-color: ${alpha(theme.palette.primary.main, 0.08)};
        `
      : css`
          border: 1px solid ${theme.palette.grey[300]};
          background-color: ${theme.palette.background.paper};

          &:hover {
            border-color: ${theme.palette.grey[400]};
            background-color: ${alpha(theme.palette.grey[500], 0.04)};
          }
        `}

  ${({ isCancelStep, theme }) =>
    isCancelStep &&
    css`
      background-color: ${alpha(theme.palette.error.main, 0.08)};
      border: 1px solid ${theme.palette.error.main};

      &:hover {
        border-color: ${theme.palette.error.main};
        background-color: ${alpha(theme.palette.error.main, 0.08)};
      }
    `}
`;

export const ChipsContainer = styled(Box)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2)};
  overflow: hidden;
  min-height: 24px;
  white-space: nowrap;
`;

export const TeamChip = styled(Chip)`
  overflow: hidden;
`;

export const TeamDot = styled(Box)<StyledTeamDotProps>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

export const RemainingChipsCounter = styled(Chip)`
  width: 35px;
  background-color: ${({ theme }) => theme.palette.grey[300]};
`;
